export default __webpack_public_path__ + "static/media/apportable.e4856b1c.svg";